<template>
    <div>
        <div v-if="showUpperPromoBlock" class="channels-promo">
            <div class="channels-promo__icon channels-promo__icon--rocket">
                <span class="channels-promo__rocket" aria-hidden="true">🚀</span>
            </div>
            <div class="channels-promo__content">
                <div class="channels-promo__title">Хотите больше каналов?</div>
                <div class="channels-promo__text">
                    Повысьте тариф: 3 канала вместо одного, аналитика, KPI и безлимитные активации.
                    Или купите дополнительный канал за 990 ₽/мес.
                </div>
                <div class="channels-promo__actions">
                    <v-btn
                        small
                        color="mainNew"
                        dark
                        :elevation="0"
                        class="channels-promo__btn"
                        @click="openBillingModal('tariff')"
                    >
                        ПОВЫСИТЬ ТАРИФ
                    </v-btn>
                    <v-btn
                        small
                        color="mainNew"
                        dark
                        :elevation="0"
                        class="channels-promo__btn"
                        @click="openBillingModal('slot')"
                    >
                        КУПИТЬ КАНАЛ
                    </v-btn>
                </div>
            </div>
        </div>
        <div v-if="showLowerPromoBlock" class="channels-promo">
            <div class="channels-promo__icon">
                <v-icon color="mainNew" size="30">mdi-plus</v-icon>
            </div>
            <div class="channels-promo__content">
                <div class="channels-promo__title">Хотите больше каналов?</div>
                <div class="channels-promo__text">
                    Добавьте канал: WhatsApp, Telegram или MAX за 990 ₽/мес.
                </div>
                <div class="channels-promo__actions">
                    <v-btn
                        small
                        color="mainNew"
                        dark
                        :elevation="0"
                        class="channels-promo__btn"
                        @click="openBillingModal('slot')"
                    >
                        КУПИТЬ КАНАЛ
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useBillingStore } from '@/store/stores/billing'

export default {
    name: 'ChannelsPromoBlocks',
    data() {
        return {
            smartBotTariffId: 'tariff2',
            maxSubscriptionPeriodMonths: 12,
        }
    },
    props: {
        project: {
            type: Object,
            required: true,
        },
    },
    computed: {
        showUpperPromoBlock() {
            if (!this.project?.billingEnabled) return false
            const tier = this.getTariffTier()
            return tier === 0 || tier === 1
        },
        showLowerPromoBlock() {
            if (!this.project?.billingEnabled) return false
            const tier = this.getTariffTier()
            return tier === 2 || tier === 3
        },
    },
    methods: {
        openBillingModal(type = 'tariff') {
            const billingStore = useBillingStore()
            if (type === 'tariff') {
                billingStore.setAddChannelContext(null)
                billingStore.selectedTariffId = this.smartBotTariffId
                billingStore.selectedSubscriptionPeriod = String(this.maxSubscriptionPeriodMonths)
                billingStore.setPaymentModalOpened(false)
                if (this.project?.id) {
                    this.$router.push(
                        `/project/${this.project.id}/billing/?section=tariffs&highlighted=true&default=${this.smartBotTariffId}&period=${this.maxSubscriptionPeriodMonths}`
                    )
                }
                return
            }
            if (typeof billingStore.setAddChannelContext === 'function') {
                if (type === 'slot') {
                    billingStore.setAddChannelContext({
                        name: 'WA/TG/MAX/SMS',
                        icon: null,
                        kind: 'bundle',
                    })
                } else {
                    billingStore.setAddChannelContext(null)
                }
            }
            billingStore.setPaymentModalOpened(true, false)
        },
        getTariffTier() {
            const billingStore = useBillingStore()
            const tariff = billingStore.getCurrentTariff(this.project.id)
            if (!tariff) return 0
            const billingTariff = billingStore.getTariffById(tariff.integrationId)
            const raw = [
                tariff.integrationId,
                tariff.name,
                billingTariff?.id,
                billingTariff?.name,
                ...(billingTariff?.tags || []),
            ]
                .filter(Boolean)
                .join(' ')
                .toLowerCase()

            if (raw.includes('tariff3') || /тариф\s*3/.test(raw)) return 3
            if (raw.includes('tariff2') || /тариф\s*2/.test(raw)) return 2
            if (raw.includes('tariff1') || /тариф\s*1/.test(raw)) return 1
            return 1
        },
    },
}
</script>

<style scoped lang="sass">
@import '@/vars.sass'

.channels-promo
    border: 1px solid #d9dce1
    border-radius: 14px
    padding: 14px 16px
    display: flex
    align-items: flex-start
    gap: 12px
    background: #fff

.channels-promo__icon
    width: 55px
    height: 55px
    border: 1px dashed $main-new
    border-radius: 50%
    display: flex
    align-items: center
    justify-content: center
    flex-shrink: 0
    background: linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)), $main-new

.channels-promo__icon--rocket
    background: #eaf3ff

.channels-promo__rocket
    font-size: 28px
    line-height: 28px
    display: block

.channels-promo__content
    min-width: 0

.channels-promo__title
    font-size: 18px
    font-weight: 700
    line-height: 16px
    letter-spacing: -0.03em
    color: #2a3b51
    margin-bottom: 6px

.channels-promo__text
    font-size: 14px
    line-height: 1.3
    color: rgba(42, 59, 81, 0.87)
    margin-bottom: 10px

.channels-promo__actions
    display: flex
    gap: 10px

::v-deep .channels-promo__btn
    box-shadow: none !important
</style>
